import { FormInstance } from 'antd/lib/form/Form'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import {
	useAddChillPackRecipientMutation,
	useGetChillPackCompaniesLazyQuery,
} from 'graphql/__generated__/graphql'

type UseRegisterFormProps = {
	form: FormInstance<any>
	handleRegistration: () => void
}

// type TChillPackCommunity = {
// 	id: string
// 	name: string
// }

export const useRegisterForm = ({
	form,
	handleRegistration,
}: UseRegisterFormProps) => {
	const [showTermsAndConditionsModal, setShowTermsAndConditionsModal] =
		useState(false)
	const [termsAndConditionsCheckbox, setTermsAndConditionsCheckox] =
		useState(false)
	const [selectedCompanyId, setSelectedCompanyId] = useState('')
	const [addChillPackRecipientrMutationHandle] =
		useAddChillPackRecipientMutation()

	const [chillPackCommunitiesOptions, setChillPackCommunitiesOptions] =
		useState<
			| {
					label: string
					value: string
			  }[]
			| undefined
		>()

	const [getChillPackCompanies, { data: chillPackCompanies }] =
		useGetChillPackCompaniesLazyQuery()

	const chillPackCompaniesData = chillPackCompanies
		? chillPackCompanies.chillPackCompanyCollection?.edges
		: []

	// TODO: replace any with the appropriate interface
	const toggleTermsAndConditionsModal = (event: any) => {
		event.preventDefault()
		setShowTermsAndConditionsModal(!showTermsAndConditionsModal)
	}

	const toggleTermsAndConditionsCheckbox = () => {
		setTermsAndConditionsCheckox(!termsAndConditionsCheckbox)
	}
	const handleAgreement = useCallback(
		(agreement: boolean) => {
			setShowTermsAndConditionsModal(false)
			setTermsAndConditionsCheckox(agreement)
		},
		[setTermsAndConditionsCheckox],
	)

	const parsedChillPackCompanies: { value: string; label: string }[] =
		useMemo(() => {
			if (!chillPackCompaniesData) return []
			else {
				return chillPackCompaniesData?.map(item => ({
					value: item.node.id,
					label: item.node.name,
				}))
			}
		}, [chillPackCompaniesData])

	const onFinish = async (values: {
		firstName: string
		lastName: string
		email: string
		company: string
	}) => {
		const { company, ...chillPackRecipientInput } = values

		try {
			await addChillPackRecipientrMutationHandle({
				variables: {
					data: {
						...chillPackRecipientInput,
						company: selectedCompanyId,
					},
				},
			})
			toast.success(
				'Inregistrarea a fost realizata cu success! Multumim.',
				{
					position: 'top-center',
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
				},
			)
			form.resetFields()
			handleRegistration()
		} catch (error) {
			// @ts-ignore
			toast.error(error.message, {
				position: 'top-center',
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			})
		}
	}

	const searchChillPackCommunities = (searchText: string) => {
		if (chillPackCompaniesData) {
			if (!searchText) {
				setChillPackCommunitiesOptions(parsedChillPackCompanies)
			} else {
				const resultedChillPackCompanies =
					parsedChillPackCompanies.filter(item => {
						return item.label
							.toLowerCase()
							.includes(searchText.toLowerCase())
					})
				setChillPackCommunitiesOptions(resultedChillPackCompanies)
			}
		} else {
			setChillPackCommunitiesOptions([])
		}
	}

	const onSelectChillPackCompany = (
		value: string,
		option: { value: string; label: string },
	) => {
		console.log('onSelect', value, option)
		setSelectedCompanyId(option.value)
		form.setFieldsValue({
			company: option.label,
		})
	}

	useEffect(() => {
		getChillPackCompanies()
	}, [getChillPackCompanies])

	useEffect(() => {
		if (!chillPackCompaniesData) return

		setChillPackCommunitiesOptions(parsedChillPackCompanies)
	}, [chillPackCompaniesData, parsedChillPackCompanies])

	return {
		toggleTermsAndConditionsCheckbox,
		toggleTermsAndConditionsModal,
		handleAgreement,
		showTermsAndConditionsModal,
		onFinish,
		termsAndConditionsCheckbox,
		chillPackCompaniesData,
		chillPackCommunitiesOptions,
		searchChillPackCommunities,
		onSelectChillPackCompany,
	}
}
